import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { TESCookieV2 } from '../shared/cookies';

const CONFIRMATION_TEXT = "Are you sure you want to delete this review?";

export const component = ({ 'review-id': reviewId, 'review-author-id': authorId, 'resource-author-id': resourceAuthorId }) => {

  const { userId } = TESCookieV2() || {};

  const isReviewOwner = Number(userId) === Number(authorId);
  const isResourceAuthor = Number(userId) === Number(resourceAuthorId);

  const review = document.getElementById(`rdp-review-item-${reviewId}`);

  const writeReplyBlock = document.getElementById(`review-${reviewId}-reply-write__section`);
  const writeReplyTextarea = document.getElementById(`review-${reviewId}-reply-write__body`);

  const show = (element) =>  element?.style?.setProperty('display', 'block');

  const showWriteReply = (event) => {
    event.stopPropagation();
    show(writeReplyBlock);
    writeReplyTextarea?.focus();
  };

  const deleteReview = async (event) => {
    event.stopPropagation();

    if (!confirm(CONFIRMATION_TEXT)) {
      return;
    }
    fetch(`/api/review/${reviewId}`, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (!response.ok) throw Error(response.statusText);
      return response;
    }).then(() => review?.remove());
  };

  return (
    <div>
      {isReviewOwner && (<div className='rdp-review__remove'>
        <a title='Remove this review' className='rdp-review__remove-link' onClick={deleteReview}>
          remove
        </a>
      </div>)}
      {isResourceAuthor && (<div className='rdp-review__write-reply'>
        <a title='Reply to this review'
           className='rdp-review__reply-link'
           id={`review-${reviewId}-reply__cta`}
           onClick={showWriteReply}>
          reply
        </a>
      </div>)}
    </div>);
};

register(component, 'review-author-buttons', [], { shadow: false });

